import { Provider } from '@angular/core'

import { AUTH_STORE_TOKEN } from '@yoshu-lib/core/tokens/auth-store.token'

import { AuthStore } from '@coty/core/auth/auth.store'

export const provideCotyAuthStore = (): Provider => ({
  provide: AUTH_STORE_TOKEN,
  useExisting: AuthStore
})
